export const ADD_ADDRESS = "Add an address";
export const HELP_TEXT = "Add an address by searching for your company name, street name or postcode below, selecting the right address and hitting confirm…";
export const COMPANY_NAME_REMOVAL_HELP_TEXT = "As this field does not require a company name, it will automatically be removed.";
export const FIND_YOUR_ADDRESS = "Find your address";
export const NO_RESULTS = "No results found";
export const ADDRESS = "Address";
export const CONFIRM = "Confirm";
export const CONFIRM_AND_USE_THIS_ADDRESS = "Confirm & use this address";